
import { GetSearchData } from 'Api/apis';
import { throttle } from 'throttle-debounce';
import { IQuickSearchPages, IQuickSearchProducts, IQuickSearchTranslations } from 'Vue/interfaces/Interfaces';
import PagesSearchCard from 'Vue/components/searchCardTypes/PagesSearchCard.vue';
import ProductsSearchCard from 'Vue/components/searchCardTypes/ProductsSearchCard.vue';
import vClickOutside from 'click-outside-vue3';

export default {
    name: 'Search',
    components: {
        ProductsSearchCard,
        PagesSearchCard,
    },
    data: () => {
        return {
            searchTerm: '',
            pages: [] as IQuickSearchPages[],
            products: [] as IQuickSearchProducts[],
            headerHeight: 0,
            translations: {} as IQuickSearchTranslations,
        };
    },
    directives: {
        /**
         * Click Outside is a vue 3 directive that will perform a function
         * when something outside of the element with the vue directive is clicked.
         * https://www.npmjs.com/package/click-outside-vue3
         */
        clickOutside: vClickOutside.directive,
    },
    methods: {
        /**
         * When a query is run, hit the endpoint and set the pages and products data used in our components
         */
        async queryTheTerm() {
            let searchData = await GetSearchData(this.searchTerm);

            this.pages = searchData.data?.pages?.length ? searchData.data.pages : [];
            this.products = searchData.data?.products?.length ? searchData.data.products : [];
        },
        /**
         * Search for products when user hits ENTER
         * @param e Key Event
         */
        searchProducts(e) {
            if (e.key == 'Enter' && this.searchTerm) {
                window.location.href = `/search?FilterCriteria.Query=${this.searchTerm}&FilterCriteria.Tab=products`;
            }
        },
        /**
         * When clicked outside of search dropdown clear our our search term (clearing out searchterm also closes search dropdown)
         */
        onClickOutside() {
            this.searchTerm = '';
        },
        getHeaderHeight() {
            let header: HTMLElement = document.querySelector('.site-header');
            return header.offsetHeight;
        },
        /**
         * Our header height changes at different breakpoints and dropdown positioning needs to be re-calculated
         */
        checkWidth() {
            if (window.outerWidth >= 768) {
                this.headerHeight = `${this.getHeaderHeight()}px`;
            } else if (window.outerWidth < 768) {
                this.headerHeight = `auto`;
            }
        },
        /**
         * Our Sitefinity Translations for the search app are located in SitefinityWebApp/ResourcePackages/BaldwinHardware/MVC/Views/Navigation/NavigationView.SecondaryNav.cshtml
         * We are pulling them into our app here for use
         */
        getTranslations() {
            let quickSearchDataContainer = document.getElementById('quickSearchTranslations');
            return JSON.parse(quickSearchDataContainer.getAttribute('data-translations'));
        },
    },
    created() {
        this.translations = this.getTranslations();
        this.checkWidth();
        window.addEventListener(
            'resize',
            throttle(100, false, () => {
                this.checkWidth();
            })
        );
    },
};
